import { render, staticRenderFns } from "./OfferWhatsAppModal.vue?vue&type=template&id=38f1d85e"
import script from "./OfferWhatsAppModal.vue?vue&type=script&lang=js"
export * from "./OfferWhatsAppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports